import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-f': {
    width: 264,
    height: 512,
    paths: [
      {
        d: 'M76.7 512V283H0V192H76.7V120.3C76.7 42.4 124.3 0 193.8 0 227.1 0 255.7 2.5 264 3.6V85H215.8C178 85 170.7 103 170.7 129.3V192H256L244.3 283H170.7V512'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/facebook-f.js
// module id = oMOH
// module chunks = 144